<script setup lang="ts">
import { computed } from 'vue';
import { Menu } from '~/types';
import { openSubmenu } from '~/utils/menu';
import { Icon } from '@iconify/vue';
import Container from '../Container.vue';

interface Props {
  item: Menu.MenuItem;
  level?: number;
}

const props = withDefaults(defineProps<Props>(), { level: 0 });
const levelCssClass = computed<string>(() => `menu-item--level-${props.level}`);
</script>

<template>
  <li
    v-if="item.enabled"
    class="menu-item"
    :class="{ [levelCssClass]: true, 'has-dropdown': item.children?.length > 0 }"
  >
    <button v-if="item.children?.length > 0" type="button" class="menu-item__label" @click.prevent="openSubmenu">
      {{ item.name }}
      <Icon icon="mdi:triangle-down" />
    </button>
    <span v-else class="menu-item__label">{{ item.name }}</span>

    <div v-if="item.children?.length > 0" class="submenu" @click.self="openSubmenu">
      <Container is-fluid class="submenu__container">
        <div class="submenu__wrapper">
          <ul class="submenu__inner">
            <template v-for="(childrenMenuItem, index) in item.children">
              <component
                :is="childrenMenuItem.component"
                v-if="childrenMenuItem?.component"
                :key="childrenMenuItem.id"
                :item="childrenMenuItem"
                :index="index"
                :level="level + 1"
              />
            </template>
          </ul>
        </div>
      </Container>
    </div>
  </li>
</template>
